import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import {Button} from '@sabre/spark-react'

export default class SigchartToolbar extends PureComponent {

    titleShowFilters = 'Show filters'
    titleDisplaySelection = 'Display selected sigcharts'

    onDisplaySelectedSigcharts = (selectedIds) => {
        for (let i = 0; i < selectedIds.length; ++i)
            this.props.actions.onDisplaySigchart(selectedIds[i])
    }

    render() {
        const disabledSelection = (this.props.selectedIds !== undefined && this.props.selectedIds.length > 0) ? false : true
        return (
            <nav className='row spark-mar-b-1'>
                <div className="col-md-12 spark-text-right">
                    <Button onClick={() => this.props.actions.onShowFilters()} icon="spark-icon-sliders"
                            title={this.titleShowFilters} iconOnly/>
                    <Button onClick={() => this.onDisplaySelectedSigcharts(this.props.selectedIds)}
                            icon='spark-icon-search' title={this.titleDisplaySelection} disabled={disabledSelection}
                            iconOnly/>
                </div>
            </nav>
        )
    }
}

SigchartToolbar.propTypes = {
    selectedIds: PropTypes.array,
    actions: PropTypes.object.isRequired
}


// WEBPACK FOOTER //
// ./src/screens/sigcharts/components/Toolbar.js